import React from "react";

import { Admin } from "../../../modules/Admin/Admin";
export function AdminPage() {
  return <Admin />;
}
